import React, { useRef, useState } from 'react';

import _ from 'lodash';
import { connect, useSelector } from 'react-redux';

import OptionDetail from '../../Components/OptionDetail/OptionDetail';
import ConfirmationModal from '../../Components/UIHeader/ConfirmationModal';
import useQuery from '../../hooks/useQuery';

function OptionDetailsPageComponent(props) {
  const isPdfContent = useSelector((state) => state.comRed.pdfDownload);
  const timer = useRef(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [title, setTitle] = useState('');
  const [msg, setMsg] = useState('');
  const query = useQuery();
  const { data, shortlistedIds } = props;
  const isShortlistedSearch = query.get('isShortlisted');

  const options = isPdfContent
    ? _.orderBy(data?.optionProviderRequestList, 'shortlistedOrder', 'asc')
    : _.orderBy(data?.optionProviderRequestList, 'optionOrder', 'asc');

  const onShortListed = (mode) => {
    timer.current && clearTimeout(timer.current);

    if (mode === 'ADD') {
      setTitle('Successfully added');
      setMsg('This property has been successfully added to shortlisted properties');
    }

    if (mode === 'REMOVE') {
      setTitle('Successfully removed');
      setMsg('This property has been removed successfully from shortlisted properties');
    }

    setShowConfirmation(true);

    timer.current = setTimeout(() => {
      setShowConfirmation(false);
    }, 8000);
  };

  const closeConfirmationModal = () => {
    setShowConfirmation(false);

    timer.current && clearTimeout(timer.current);
  };

  return (
    <div id="optionDetail_top">
      {showConfirmation && (
        <ConfirmationModal msg={msg} title={title} onClose={closeConfirmationModal} />
      )}

      {options &&
        !isShortlistedSearch &&
        options.map((option, idx) => (
          <div className="optionDetail" key={option.id}>
            <OptionDetail
              option={option}
              idProp={option.id}
              showNav={true}
              shortListed={onShortListed}
              idx={idx}
            />
          </div>
        ))}

      {options &&
        isShortlistedSearch &&
        shortlistedIds.length > 0 &&
        options.map((option, idx) => (
          <div className="optionDetail" key={option.id}>
            <OptionDetail
              option={option}
              idProp={option.id}
              showNav={true}
              shortListed={onShortListed}
              idx={idx}
              isShortlistedSearch={isShortlistedSearch}
            />
          </div>
        ))}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    data: state.optRed.data,
    shortlistedIds: state.shortlistRed.shortlistedIds,
  };
};

export default connect(mapStateToProps)(OptionDetailsPageComponent);
